var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Builder, BuilderComponent } from '@builder.io/react';
import { useRouter } from 'next/router';
import { DEFAULT_ACCOUNT, DEFAULT_EXTENDED_USER_PROFILE, DEFAULT_SESSION, STATIC_ACCOUNT, STATIC_EXTENDED_SESSION, STATIC_EXTENDED_USER_PROFILE, useCurrentAccount, useSession, useUserProfile, } from '../data';
import { useDeepCompareEffect } from '../utils/useDeepCompareEffect';
import { useTracking } from '../tracking';
export function Entry(_a) {
    var { content, onAsyncDataChange, onContentLoaded, data = {} } = _a, rest = __rest(_a, ["content", "onAsyncDataChange", "onContentLoaded", "data"]);
    const asyncData = useAsyncData(content === null || content === void 0 ? void 0 : content.dataSets);
    const { emitUserInteractionEvent } = useTracking();
    useDeepCompareEffect(() => {
        if (onAsyncDataChange)
            onAsyncDataChange(asyncData);
    }, [asyncData]);
    return (_jsx(BuilderComponent, Object.assign({}, rest, { context: Object.assign({ emitUserInteractionEvent }, rest.context), contentLoaded: (data) => {
            if (onContentLoaded) {
                onContentLoaded(data);
            }
        }, content: content || undefined, model: content === null || content === void 0 ? void 0 : content.model, data: Object.assign(Object.assign({}, asyncData), data) })));
}
export const useAsyncData = (dataSets) => {
    var _a, _b, _c, _d;
    const router = useRouter();
    const { data: user, isLoading: userIsLoading } = useSession(!!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.user));
    const { data: userProfile, isLoading: userProfileIsLoading } = useUserProfile(!!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.userProfile));
    const { data: currentAccount, isLoading: currentAccountIsLoading } = useCurrentAccount(!!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.currentAccount));
    if (Builder.isEditing || Builder.isPreviewing) {
        return {
            currentAccount: STATIC_ACCOUNT,
            user: STATIC_EXTENDED_SESSION,
            userProfile: STATIC_EXTENDED_USER_PROFILE,
            queryParameters: {
                demo_source: 'example_demo_source',
                utm_campaign: 'example_utm_campaign',
                utm_medium: 'example_utm_medium',
                utm_source: 'example_utm_source',
            },
        };
    }
    return {
        currentAccount: Object.assign(Object.assign(Object.assign({}, DEFAULT_ACCOUNT), currentAccount), { is_loading: currentAccountIsLoading }),
        user: Object.assign(Object.assign(Object.assign({}, DEFAULT_SESSION), user), { is_loading: userIsLoading }),
        userProfile: Object.assign(Object.assign(Object.assign({}, DEFAULT_EXTENDED_USER_PROFILE), userProfile), { is_loading: userProfileIsLoading }),
        queryParameters: {
            demo_source: (_a = router.query.demo_source) !== null && _a !== void 0 ? _a : '',
            utm_campaign: (_b = router.query.utm_campaign) !== null && _b !== void 0 ? _b : '',
            utm_medium: (_c = router.query.utm_medium) !== null && _c !== void 0 ? _c : '',
            utm_source: (_d = router.query.utm_source) !== null && _d !== void 0 ? _d : '',
        },
    };
};
//# sourceMappingURL=Entry.js.map